export interface RestrictionInterface {
  isRestricted?: boolean;
  restriction?: string;
}
